import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

// Auth
export const authSession = (session_id) => client.post("/auth/session", { session_id }).then((r) => r.data);
export const firebaseLogin = (id_token) => client.post("/auth/firebase-login", { id_token }).then((r) => r.data);
export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const authLogout = () => client.post("/auth/logout").then((r) => r.data);
// CMS
export const cmsList = (params) => client.get("/cms/articles", { params }).then((r) => r.data);
export const cmsGet = (id) => client.get(`/cms/articles/${id}`).then((r) => r.data);
export const cmsCreate = (payload) => client.post("/cms/articles", payload).then((r) => r.data);
export const cmsUpdate = (id, payload) => client.put(`/cms/articles/${id}`, payload).then((r) => r.data);
export const cmsSubmit = (id) => client.post(`/cms/articles/${id}/submit`).then((r) => r.data);
export const cmsPublish = (id) => client.post(`/cms/articles/${id}/publish`).then((r) => r.data);
export const cmsReject = (id) => client.post(`/cms/articles/${id}/reject`).then((r) => r.data);
export const linkPreview = (url) => client.get("/link-preview", { params: { url } }).then((r) => r.data);
export const getDocket = (id) => client.get(`/docket/${id}`).then((r) => r.data);
export const getNavTaxonomy = () => client.get("/nav-taxonomy").then((r) => r.data);

export const getStats = () => client.get("/stats").then((r) => r.data);
export const getLanguages = () => client.get("/languages").then((r) => r.data);
export const getFeaturedStates = () => client.get("/states", { params: { featured: true } }).then((r) => r.data);
export const getStates = () => client.get("/states").then((r) => r.data);
export const getNavData = () => client.get("/nav-data").then((r) => r.data);
export const getStateCities = (stateSlug) => client.get(`/state-cities/${stateSlug}`).then((r) => r.data);
export const getPlaceFacts = (geoId) => client.get(`/place-facts/${geoId}`).then((r) => r.data);
export const getPlaceAlerts = (geoId) => client.get(`/place-alerts/${geoId}`).then((r) => r.data);
export const getPlaceReadiness = (geoId) => client.get(`/place-readiness/${geoId}`).then((r) => r.data);
export const getPlaceCivic = (geoId) => client.get(`/place-civic/${geoId}`).then((r) => r.data);
export const getGeo = (geoId) => client.get(`/geo/${geoId}`).then((r) => r.data);
export const getPlace = (path) => client.get("/place", { params: { path } }).then((r) => r.data);
export const search = (q) => client.get("/search", { params: { q } }).then((r) => r.data);
export const translate = (texts, target, target_name) =>
  client.post("/translate", { texts, target, target_name }).then((r) => r.data);
export const getContributions = (geoId, module) =>
  client.get("/contributions", { params: { geo_id: geoId, ...(module ? { module } : {}) } }).then((r) => r.data);
export const createContribution = (payload) =>
  client.post("/contributions", payload).then((r) => r.data);
export const getModerationQueue = (status = "pending") =>
  client.get("/moderation/contributions", { params: { status } }).then((r) => r.data);
export const moderateContribution = (cid, action, reason) =>
  client.post(`/moderation/contributions/${cid}/${action}`, { reason }).then((r) => r.data);
export const getPlaceNav = (geoId) => client.get(`/place-nav/${geoId}`).then((r) => r.data);
export const getStateSymbols = (geoId) => client.get(`/state-symbols/${geoId}`).then((r) => r.data);
export const getArchiveRecovery = () => client.get("/archive-recovery").then((r) => r.data);
export const getRegion = (key) => client.get(`/region/${key}`).then((r) => r.data);
export const getRegions = () => client.get("/regions").then((r) => r.data);

// Community — PhotoPulse (photo uploads) + ChatsPulse (discussions)
export const BACKEND_BASE = BACKEND_URL;
export const communityPhotos = (geoId) =>
  client.get("/community/photos", { params: { geo_id: geoId } }).then((r) => r.data);
export const uploadCommunityPhoto = (formData) =>
  client.post("/community/photos/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const chatThreads = (geoId, topic) =>
  client.get("/community/threads", { params: { geo_id: geoId, topic: topic || undefined } }).then((r) => r.data);
export const chatThread = (tid) => client.get(`/community/threads/${tid}`).then((r) => r.data);
export const createChatThread = (payload) => client.post("/community/threads", payload).then((r) => r.data);
export const createChatReply = (tid, payload) => client.post(`/community/threads/${tid}/replies`, payload).then((r) => r.data);
export const flagChatThread = (tid) => client.post(`/community/threads/${tid}/flag`).then((r) => r.data);
export const flagChatReply = (rid) => client.post(`/community/replies/${rid}/flag`).then((r) => r.data);

// Community moderation (admin, cookie session)
export const modPhotos = (status = "pending") => client.get("/community/moderation/photos", { params: { status } }).then((r) => r.data);
export const modPhotoAction = (id, action) => client.post(`/community/moderation/photos/${id}/${action}`).then((r) => r.data);
export const modChats = (status = "flagged") => client.get("/community/moderation/chats", { params: { status } }).then((r) => r.data);
export const modChatAction = (id, action) => client.post(`/community/moderation/chats/threads/${id}/${action}`).then((r) => r.data);
export const getSymbolOfTheDay = () => client.get("/symbol-of-the-day").then((r) => r.data);
export const getSourcesRegistry = () => client.get("/sources-registry").then((r) => r.data);
export const getFlagsGallery = () => client.get("/flags-gallery").then((r) => r.data);
export const getCompareFacts = (geoId) => client.get(`/compare-facts/${geoId}`).then((r) => r.data);
export const getRegionWeather = (key) => client.get(`/region/${key}/weather`).then((r) => r.data);
export const getQuizLeaderboard = () => client.get("/quiz/leaderboard").then((r) => r.data);
export const submitQuizScore = (payload) => client.post("/quiz/score", payload).then((r) => r.data);
export const getArchiveRecords = (kind) => client.get("/admin/archive-recovery/records", { params: kind ? { kind } : {} }).then((r) => r.data);
export const getPlaceArticle = (geoId, moduleKey) =>
  client.get(`/place-article/${geoId}/${moduleKey}`).then((r) => r.data);
export const askAssistant = (payload) => client.post("/assistant", payload).then((r) => r.data);
export const getPrewarmedCities = (limit = 300) =>
  client.get("/prewarmed-cities", { params: { limit } }).then((r) => r.data);
export const getPlaceFaq = (geoId) => client.get(`/place-faq/${geoId}`).then((r) => r.data);
export const getPeople = (curated = true) => client.get("/people", { params: { curated } }).then((r) => r.data);
export const getPerson = (id) => client.get(`/people/${id}`).then((r) => r.data);
export const getPersonArticle = (id) => client.get(`/person-article/${id}`).then((r) => r.data);
export const getPresidents = () => client.get("/presidents").then((r) => r.data);
export const getPhoto = (query) => client.get("/photo", { params: { query } }).then((r) => r.data);
export const getPlaceToday = (geoId) => client.get(`/place-today/${geoId}`).then((r) => r.data);
export const getLocalNews = (geoId, limit = 8) => client.get(`/local-news/${geoId}`, { params: { limit } }).then((r) => r.data);
export const getPlacePhoto = (geoId) => client.get(`/place-photo/${geoId}`).then((r) => r.data);
export const getLocalEvents = (geoId, limit = 5) => client.get(`/local-events/${geoId}`, { params: { limit } }).then((r) => r.data);
export const getContentStats = () => client.get("/admin/content-stats").then((r) => r.data);
export const getSSOSites = () => client.get("/admin/sso-sites").then((r) => r.data);
export const setSSOStatus = (slug, status, note = "") =>
  client.post(`/admin/sso-sites/${slug}/status`, { status, note }).then((r) => r.data);
export const adminSsoSites = () => client.get("/admin/sso-sites").then((r) => r.data);
export const adminSetSsoStatus = (slug, status, note = "") =>
  client.post(`/admin/sso-sites/${slug}/status`, { status, note }).then((r) => r.data);
export const homesToggleSearchAlerts = (id, enabled) =>
  client.post(`/homes/saved/searches/${id}/alerts`, { enabled }).then((r) => r.data);

// HomesPulse (real-estate vertical)
export const homesStats = () => client.get("/homes/stats").then((r) => r.data);
export const homesFeaturedCities = (limit = 12) =>
  client.get("/homes/featured-cities", { params: { limit } }).then((r) => r.data);
export const homesSearch = (params) => client.get("/homes/listings", { params }).then((r) => r.data);
export const homesListing = (id) => client.get(`/homes/listings/${id}`).then((r) => r.data);
export const homesValuation = (id) => client.get(`/homes/listings/${id}/valuation`).then((r) => r.data);
export const homesPlace = (geoId, limit = 12) =>
  client.get(`/homes/place/${geoId}`, { params: { limit } }).then((r) => r.data);
export const homesAgents = (params) => client.get("/homes/agents", { params }).then((r) => r.data);
export const homesAgent = (id) => client.get(`/homes/agents/${id}`).then((r) => r.data);
export const homesCreateListing = (payload) => client.post("/homes/listings", payload).then((r) => r.data);
export const homesMyListings = () => client.get("/homes/my-listings").then((r) => r.data);
export const homesSetListingStatus = (id, listing_status) =>
  client.post(`/homes/listings/${id}/status`, { listing_status }).then((r) => r.data);
export const homesUploadPhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/homes/listings/photo", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const homesUploadDocument = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/homes/listings/document", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const homesNeighborhood = (geoId) => client.get(`/homes/neighborhood/${geoId}`).then((r) => r.data);
export const homesUpdateListing = (id, payload) => client.patch(`/homes/listings/${id}`, payload).then((r) => r.data);
export const homesSimilarListings = (id) => client.get(`/homes/listings/${id}/similar`).then((r) => r.data);
export const homesReportListing = (id, payload) => client.post(`/homes/listings/${id}/report`, payload).then((r) => r.data);
export const homesAiDescription = (facts) => client.post("/homes/ai/description", facts).then((r) => r.data);
export const homesAdvisor = (query, session_id = "advisor") =>
  client.post("/homes/advisor", { query, session_id }).then((r) => r.data);

// HomesPulse — saved homes, saved searches & alerts
export const homesSavedIds = () => client.get("/homes/saved/ids").then((r) => r.data);
export const homesSaveListing = (id) => client.post(`/homes/saved/listings/${id}`).then((r) => r.data);
export const homesUnsaveListing = (id) => client.delete(`/homes/saved/listings/${id}`).then((r) => r.data);
export const homesSavedListings = () => client.get("/homes/saved/listings").then((r) => r.data);
export const homesSaveSearch = (params, name) => client.post("/homes/saved/searches", { params, name }).then((r) => r.data);
export const homesSavedSearches = () => client.get("/homes/saved/searches").then((r) => r.data);
export const homesDeleteSearch = (id) => client.delete(`/homes/saved/searches/${id}`).then((r) => r.data);
export const homesMarkSearchSeen = (id) => client.post(`/homes/saved/searches/${id}/seen`).then((r) => r.data);
export const homesAlertsCount = () => client.get("/homes/alerts/count").then((r) => r.data);

// HomesPulse — relocation guides
export const homesRelocationHub = (limit = 24) =>
  client.get("/homes/relocation", { params: { limit } }).then((r) => r.data);
export const homesRelocationGuide = (geoId) =>
  client.get(`/homes/relocation/${geoId}`).then((r) => r.data);

// HomesPulse — agent subscriptions & microsites
export const homesTiers = () => client.get("/homes/tiers").then((r) => r.data);
export const homesMyAgentAccount = () => client.get("/homes/agent-account/me").then((r) => r.data);
export const homesSaveAgentAccount = (payload) =>
  client.post("/homes/agent-account", payload).then((r) => r.data);
export const homesMicrosite = (slug) => client.get(`/homes/agent/${slug}`).then((r) => r.data);
export const homesCheckout = (lookup_key) =>
  client.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data);
export const homesPaymentStatus = (sessionId) =>
  client.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const homesShorten = (long_url, alias) =>
  client.post("/homes/shorten", { long_url, alias }).then((r) => r.data);

// USAPulse — branded share links + QR (SpLink usapulse tenant)
export const shareLink = ({ path, url, alias } = {}) =>
  client.post("/share-link", { path, url, alias }).then((r) => r.data);

// HomesPulse — city comparison
export const homesCompare = (a, b) => client.get("/homes/compare", { params: { a, b } }).then((r) => r.data);

// HomesPulse — marketing center (SpLink QR kit + scan stats)
export const homesMarketingKit = (listingId) => client.post(`/homes/marketing/listing/${listingId}`).then((r) => r.data);
export const homesMarketingStats = (slug) => client.get(`/homes/marketing/stats/${slug}`).then((r) => r.data);
export const homesSetQrMode = (listingId, mode) => client.post(`/homes/marketing/listing/${listingId}/mode`, { mode }).then((r) => r.data);

// HomesPulse — Agent CRM
export const crmDashboard = () => client.get("/homes/crm/dashboard").then((r) => r.data);
export const crmLeads = (params = {}) => client.get("/homes/leads", { params }).then((r) => r.data);
export const crmCreateLead = (payload) => client.post("/homes/leads", payload).then((r) => r.data);
export const crmUpdateLead = (id, patch) => client.patch(`/homes/leads/${id}`, patch).then((r) => r.data);
export const crmAddNote = (id, text) => client.post(`/homes/leads/${id}/notes`, { text }).then((r) => r.data);
export const crmDeleteLead = (id) => client.delete(`/homes/leads/${id}`).then((r) => r.data);
export const crmCaptureLead = (payload) => client.post("/homes/leads/capture", payload).then((r) => r.data);
export const crmToday = () => client.get("/homes/crm/today").then((r) => r.data);
export const crmLeadMatches = (id) => client.get(`/homes/leads/${id}/matches`).then((r) => r.data);
export const crmLeadMarketing = (id) => client.get(`/homes/leads/${id}/marketing`).then((r) => r.data);
export const crmDraftEmail = (id) => client.post(`/homes/leads/${id}/draft-email`).then((r) => r.data);

export default client;
